module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section02_06_beach-photo-9bbaeee34b36f04bc8884d243954a5a4.jpg";